import { MultiMenuTooltip } from 'components/common'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { lang } from 'utils/helpers'
import inchatActions from 'redux/inchat/actions'
import { toastMessage } from 'utils/messages'
import { useHistory } from 'react-router-dom'
import { removeUserTabs } from 'redux/actions/tabs'
import ModalDelete from 'components/ModalDelete'

const MenuChannel = ({
  hideMenu,
  conversation,
  conversationAction,
  openModalChannelView
}) => {
  const { isMuted } = conversation
  const dispatch = useDispatch()
  const history = useHistory()
  const [openModalExit, setOpenModalExit] = useState(false)

  const actionChannel = async (type='mute') => {
    try {
      let body = {
        type,
        conversationId: conversation._id,
        conversationType: conversation.type,
      }
      await conversationAction(body)
      if(type === 'leave'){
        dispatch(removeUserTabs(conversation._id))
        history.push(`${history.location.pathname}`)
        dispatch(inchatActions.removeConversationChannel(conversation._id))
      }
    } catch (error) {
      toastMessage(getTextError(type), 'error')
    }
  }

  const getTextError = (type) => {
    switch (type) {
      case 'mute':
        return lang('dashboard_error-mute-channel')
      case 'unmute':
        return lang('dashboard_error-unmute-channel')
      case 'leave':
        return lang('dashboard_error_channel_exit')
      default:
        break
    }
  }

  const copyLinkChannel = () => {
    const textToNavigate = window.location.href.split('?')
    const textToClipboard = `${textToNavigate[0]}?user_id=${conversation._id}`
    navigator.clipboard.writeText(textToClipboard)
    toastMessage(lang('dashboard_channel-copied-clipboard'))
  }

  return (
    <>
      <MultiMenuTooltip
        isHide={hideMenu}
        dotsOrientation='horizontal'
        dotsColor='#999999'
        options={[
          [
            {
              label: isMuted ? lang('dashboard_unmute_channel') : lang('dashboard_mute_channel'),
              onClick: () => actionChannel(isMuted ? 'unmute': 'mute')
            },
            {
              label: lang('dashboard_copy_channel_link'),
              onClick: () => copyLinkChannel(),
              closeMenu: true
            },
            {
              label: lang('dashboard_view_channel_details'),
              onClick: () => openModalChannelView(),
              closeMenu: true
            }
          ],
          [
            {
              label: lang('dashboard_exit_channel'),
              onClick: () => setOpenModalExit(!openModalExit),
              closeMenu: true
            }
          ]
        ]}
      />
      {openModalExit ?
        <ModalDelete
          isOpen={openModalExit}
          toggle={() => {
            setOpenModalExit(!openModalExit)
          }}
          header={lang('dashboard_exit_channel')}
          text1={lang('dashboard_exit_channel_questions')}
          text2={lang('dashboard_exit_channel_legend')}
          event={() => actionChannel('leave')}
          textBtn1={lang('dashboard_leave')}
        /> : null
      }
    </>
  )
}

export default MenuChannel